@if(loaderService.isLoading$ | async){<div class="loader-overlay">
    <div class="svg-loader">
        <svg viewBox="25 25 50 50">
            <circle class="loader-circle" cx="50" cy="50" r="20"></circle>
        </svg>
        <small class="loading-text">Loading</small>
    </div>
</div>
}